// src/components/skeletons/ProductCardCarouselSkeleton.tsx

export const ProductCardCarouselSkeleton = () => {
  return (
    <section className="product padding-bottom">
      <div className="container">
        <div className="section-header">
          <h2
            style={{
              width: '380px',
              height: '50px',
              borderRadius: '24px',
            }}
            className="section-title placeholder "
          ></h2>
        </div>
        <div className="d-flex gap-3 overflow-hidden">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="card placeholder "
              style={{ minWidth: '220px', border: 'none' }}
            >
              <div
                className="placeholder "
                style={{ height: '220px', width: '100%' }}
              ></div>
              <div className="card-body">
                <span className="placeholder  col-8"></span>
                <span className="placeholder  col-5 mt-2"></span>
                <span className="placeholder  col-6 mt-3"></span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
